export const set = (key: string, value: any) => {
	localStorage.setItem(key, JSON.stringify(value));
};

export const get = (key: string) => {
	const item = localStorage.getItem(key);
	if (item) {
		return JSON.parse(item);
	}
	return null;
};

export const remove = (key: string) => {
	localStorage.removeItem(key);
};

export const removeKeys = (keys: string[]) => {
	keys.forEach(key => {
		localStorage.removeItem(key);
	});
};

export default {
	set,
	get,
	remove,
	removeKeys,
};
